// PRODUCT ORDER
import WDHProductOrder from "../../../../wdh-feature/wdh-product-order/src/js/wdh-product-order";
var productOrder = new WDHProductOrder();
productOrder.run();